// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { EstimateSaveRequest } from '../Classes/EstimateSaveRequest';
import { CollaboratorDetails } from '../Classes/CollaboratorDetails';
export class TurnoverToSalesRequest {
  saveRequest: EstimateSaveRequest;
  isOwnershipChangeNeeded: boolean;
  collaborators: CollaboratorDetails[];
  turnoverUpdateNotes: string;
  collaboratorsModificationNotes: string;
}
